/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandSpeedtest = createReactComponent("brand-speedtest", "IconBrandSpeedtest", [
  ["path", { d: "M5.636 19.364a9 9 0 1 1 12.728 0", key: "svg-0" }],
  ["path", { d: "M16 9l-4 4", key: "svg-1" }]
]);

export { IconBrandSpeedtest as default };
//# sourceMappingURL=IconBrandSpeedtest.js.map
